import getListOfSundays from '../utils/getListOfSundays.utils'
import listOfDaysAfterFirstSunday from '../utils/listOfDaysAfterFirstSunday.utils'

const getLotMaxDate = (
    lotId: string,
    startDate: Date | null,
    endDate: Date | null
): { maxDate: Date | null; excludeDates: Date[] } => {
    switch (lotId) {
        // greifcenter outdoor
        case 'A538': {
            return {
                maxDate: null,
                excludeDates:
                    startDate && endDate === null ? listOfDaysAfterFirstSunday(startDate, 4) : getListOfSundays()
            }
        }
        default: {
            return {
                maxDate: null,
                excludeDates: []
            }
        }
    }
}

const getLotMinDate = (lotId: string): Date => {
    switch (lotId) {
        default: {
            return new Date()
        }
    }
}

export const hardcodedDailyBookingRules = (
    lotId: string,
    startDate: Date | null,
    endDate: Date | null
): { maxDate: Date | null; excludeDates: Date[]; minDate: Date } => {
    const { maxDate, excludeDates } = getLotMaxDate(lotId, startDate, endDate)
    const minDate = getLotMinDate(lotId)

    return {
        maxDate,
        excludeDates,
        minDate
    }
}
